<template>
  <div id="ly_scenic">

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
      addText="添加景区" @addFn="addScenic">
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="148px">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" @click="manageTicket(row)">票种</el-button>
            <el-dropdown @command="handleCommand($event, row)" style="margin-left: 10px;">
              <el-button type="text">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="up" v-if="row.status === 2">上架</el-dropdown-item>
                <el-dropdown-item command="down" v-else>下架</el-dropdown-item>
                <el-dropdown-item command="edit">编辑</el-dropdown-item>
                <el-dropdown-item command="delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'name'">
          <el-tag v-if="row.status === 1" size="small" type="success">上架</el-tag>
          <el-tag v-else type="info" size="small">下架</el-tag>
          <span style="margin-left: 8px;">{{ row.name }}</span>
        </template>
        <template v-else-if="item.prop === 'city'">
          <span>{{ row.province && row.city ? `${row.province} / ${row.city}` : '-' }}</span>
        </template>
        <template v-else-if="item.prop === 'minPrice'">
          <span class="util-money">¥{{ row.minPrice || '-' }}</span>
        </template>
        <template v-else-if="item.prop === 'level'">
          <el-tag v-if="row.level" size="mini" type="warning">{{ row.level }}</el-tag>
          <span v-else>-</span>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] !== null && row[item.prop] !== undefined ? row[item.prop] : '-' }}</span>
        </template>
      </template>
    </custom-table>
  </div>
</template>

<script>
import { cityCodeJson } from "@/assets/js/city";
export default {
  name: "ly_scenic",
  data() {
    return {
      customOptions: {
        url: "/api/v1/manage/travelScenic",
        params: { page: 1, size: 20 },
        search: [
          { type: "input", field: "name", name: "景区名称", value: "" },
          {
            type: "cascader", field: "cityCode", name: "城市", value: "", option: cityCodeJson,
            props: { label: "name", value: "citycode", children: "districts" }
          },
          {
            type: "select", field: "level", name: "景区等级", value: "",
            option: [
              { label: "5A", value: "5A" }, { label: "4A", value: "4A" },
              { label: "3A", value: "3A" }, { label: "2A", value: "2A" }, { label: "其他", value: "其他" }
            ]
          },
          {
            type: "select", field: "status", name: "状态", value: "",
            option: [{ label: "上架", value: 1 }, { label: "下架", value: 2 }]
          },
        ],
      },
      columns: [
        { prop: "name", label: "景区名称", minWidth: 200 },
        { prop: "level", label: "等级", width: 80 },
        { prop: "city", label: "城市", minWidth: 150 },
        { prop: "address", label: "地址", minWidth: 200 },
        { prop: "contactPhone", label: "联系电话", width: 130 },
        { prop: "minPrice", label: "最低票价", width: 100 },
        { prop: "openTime", label: "开放时间", width: 150 },
        { prop: "ticketCount", label: "票种数", width: 80 },
      ],
    };
  },
  methods: {
    addScenic() {
      this.$router.push({ path: '/ly_scenicCreate' });
    },
    manageTicket(row) {
      this.$router.push({ path: '/ly_scenicTicket', query: { scenicId: row.id, scenicName: row.name } });
    },
    handleCommand(command, row) {
      if (command === 'edit') {
        this.$router.push({ path: '/ly_scenicEdit', query: { id: row.id } });
      } else if (command === 'delete') {
        this.$confirm('删除后无法恢复，是否删除该景区？', '删除景区', {
          confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning'
        }).then(async () => {
          let { code } = await this.$axios.delete('/api/v1/manage/travelScenic', { id: row.id });
          if (code === 1) { this.$message.success('删除成功'); this.$refs.customTable.listFn(); }
        }).catch(() => {});
      } else if (command === 'up') {
        this.$confirm('是否上架该景区？', '上架景区', {
          confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning'
        }).then(async () => {
          let { code } = await this.$axios.put('/api/v1/manage/travelScenic/status', { id: row.id, status: 1 });
          if (code === 1) { this.$message.success('上架成功'); this.$refs.customTable.listFn(); }
        });
      } else if (command === 'down') {
        this.$confirm('下架后景区将不再展示，是否下架？', '下架景区', {
          confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning'
        }).then(async () => {
          let { code } = await this.$axios.put('/api/v1/manage/travelScenic/status', { id: row.id, status: 2 });
          if (code === 1) { this.$message.success('下架成功'); this.$refs.customTable.listFn(); }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#ly_scenic {
  .custom-action {
    display: flex; align-items: center;
    .el-button--text { padding: 0; color: #2B77FF; }
  }
  .util-money { font-weight: 600; color: #F56C6C; }
}
</style>
